module.exports = __webpack_public_path__ + "media/src/admin/images/calender-bg-6e883cfda6770d415c2ab9675d4fb955.png";